import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { formatLineChartTooltip } from "./utils";

export function translateRecoveryPVIResponseTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  const { layout, hoverLegendItemUnfilteredRef, series, sum, multiProduct } = states;

  const yAxisTitle = layout?.yAxis?.title || "";

  return {
    trigger: "axis",
    confine: true,
    enterable: true,
    extraCssText: "border-style:none;",
    showDelay: 500,
    hideDelay: 0,
    show: true,
    axisPointer: {
      label: {
        precision: 2,
        show: true
      },
      type: "cross"
    },
    position: function (point, _, dom) {
      const xPos = point[0];
      const yPos =
        point[1] - (dom as HTMLDivElement).offsetHeight > 48
          ? point[1] - (dom as HTMLDivElement).offsetHeight
          : 48;
      return [xPos, yPos];
    },
    formatter: (items) =>
      formatLineChartTooltip(
        items,
        hoverLegendItemUnfilteredRef?.current,
        series,
        yAxisTitle,
        sum?.active,
        layout,
        multiProduct?.active
      )
  };
}
